import {
    Dispatch,
    SetStateAction,
    createContext,
    useContext,
    useState,
} from 'react'
import { Lease, LeaseStatus } from '../types/lease'
import { axiosInstance } from '../helpers'

export interface ILeaseContext {
    leaseList: Lease[] | null
    setLeaseList: Dispatch<SetStateAction<Lease[] | null>>
}

export const LeaseContext = createContext<ILeaseContext>(
    null as unknown as ILeaseContext,
)

export const useLease = () => {
    const state = useContext(LeaseContext)

    const getLeases = async () => {
        axiosInstance
            .get('lease/lease-tenant/', {
                params: {
                    occupiable: true,
                    root_lease: true,
                },
            })
            .then((res) => {
                state.setLeaseList(res.data)
            })
    }

    return {
        leaseList: state.leaseList,
        getLeases,
    }
}

export const useLeaseState = (): ILeaseContext => {
    const [leaseList, setLeaseList] = useState<Lease[] | null>(null)

    return {
        leaseList,
        setLeaseList,
    }
}
